<template>
    <div class="bucket-wrapper chart">
        <div v-for="(bucket, index) in bucketNote" :key="bucket.id" class="event-section">

            <!-- Top naivagation for events that can be opened and closed  -->
            <div v-if="bucket.type === 'event'" class="bucket-header" :key="renderKey">
                <img 
                    @click="toggleEventSection(index)" 
                    class="event-chevron" 
                    :src="isBucketExpanded[index] ? require('../image/event-expanded.png') : require('../image/event-collapsed.png')" 
                /> 
                {{ getContentKey('event', bucket.event, 'name') }}
                <span class="bucket-provider">
                    {{ formatDate(bucket.time) }}
                </span>
                <span class="bucket-provider">
                    {{ getProviderNameById(bucket.provider) }}
                    <!-- {{ getProfileFromProvider(bucket.provider, patient) }} -->
                </span>
                <span class="flex-full"></span>
                <button @click="copy(bucket.note.map(({result}) => result.replaceAll('\n', '<br>')).join(' <br> -- <br> <br> '))" class="copy-button" type="text" size="medium">
                    <i class="el-icon-copy-document"></i> Copy All
                </button>
                <NotesDialog 
                    :patient="patient"
                    :notes="bucket.note"
                    :name="getContentKey('event', bucket.event, 'name')"
                    :provider="bucket.provider"
                    :providerName="getProviderNameById(bucket.provider)"
                    :schedule="bucket.id"
                    :date="formatDate(bucket.time)"
                    :integration="bucket.integration"
                    :has-push-integration="pushIntegration.includes(bucket.provider) && bucket.type === 'event'"
                    :emr-category="bucket.emrCategory"
                    :comb-note-disabled="bucket.disabled"
                    :chart-map-for-patient="chartMapForPatient"
                    @push-notes="saveEventNote(bucket.note, bucket.id, bucket.provider)"
                    ></NotesDialog>
                
            </div>
            <div v-else-if="bucket.note && bucket.note.length > 0" class="bucket-header chart">
                <img 
                    @click="toggleEventSection(index)" 
                    class="event-chevron" 
                    :src="isBucketExpanded[index] ? require('../image/other-expanded.png') : require('../image/other-collapsed.png')" 
                /> 
            </div>

            <template v-if="isBucketExpanded[index]">
                <el-card v-for="note in bucket.note"
                    :key="note.id"
                    class="select-wrapper">
                    <div :class="['select-text', {selected: showSelected && allNotesModel[note.id]}]" >
                        <span>
                            <el-tooltip v-if="hasAutoPushEnabled(note.questionnaire_id, bucket.event)" content="Auto Push Enabled" :open-delay="2000" effect="dark">
                                <img  class="autopush-icon" :src="require('../image/autopush.png')" />
                            </el-tooltip>
                            <span class="questionnaire-title">{{ note.title }}</span>
                            <span class="oval">&bull;</span>
                            <span class="questionnaire-date">Responded on {{ note.displayTime }}</span>

                            <template v-if="pushIntegration.includes(bucket.provider) && bucket.type === 'event'" >
                                <el-tooltip :disabled="!bucket.disabled" class="push-btn-container" content="Disabled for manually created events">

                                    
                                    <div v-if="note.question_emrs" class="smart-push">
                                        <button 
                                            class="push-button"
                                            :disabled="bucket.disabled || pushingNotes[note.id]"
                                            @click="saveNote(note, bucket.id, bucket.provider)">
                                            {{ pushingNotes[note.id] ? '&nbsp;Pushing ' : 'Smart Push' }} 
                                        </button>
                                        <!-- <span v-if="note.lastPushed">Last Pushed {{ note.lastPushed }}</span> -->
                                    </div>


                                    <el-dropdown v-else-if="note.emrCategory.length > 0" :disabled="bucket.disabled" @command="openEmrConfirmation" class="category-dropdown">
                                            <button :disabled="bucket.disabled" class="push-button">
                                                Push <i class="el-icon-arrow-down"></i>
                                            </button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                :key="emr.id"
                                                v-for="emr in note.emrCategory"
                                                placement="bottom"
                                                :command="{...note, event: bucket.event, emrId: emr.id, emrTitle: emr.title , schedule: bucket.id, provider:bucket.provider, hasAutoPushEnabled: hasAutoPushEnabled(note.questionnaire_id, bucket.event), pushType: 'questionnaire'}">
                                                <div class="dropdwn-cnt">
                                                    <span class="option-title">{{ emr.title }} </span>
                                                    <span v-if="emr.last_pushed && emr.last_pushed !== ''" class="timestamp">
                                                        <span id="content1" style="line-height: 13px; margin-top: 10px" v-html="getFormattedLastPushed(emr.last_pushed)"></span>
                                                    </span>
                                                </div>
                                            </el-dropdown-item>
                                            <span class="info" v-if="note.emrCategory.some(({disabled}) => disabled)">
                                                <img :src="require('../image/info-icon.png')" />
                                                Notes have been Pushed to {{ note.emrCategory.filter((emr) => emr.disabled).map(({ title }) => `'${title}'`).join(', ') }}
                                            </span>
                                        </el-dropdown-menu>
                                    </el-dropdown>


                                    <button
                                        v-else
                                        class="push-button"
                                        :disabled="bucket.disabled || pushingNotes[note.id] || (note.integration ? note.integration.push_to_emr.default : false)"
                                        @click="saveNote(note, bucket.id, bucket.provider)">
                                        {{ pushingNotes[note.id] ? '&nbsp;Pushing ' : 'Push' }}
                                    </button>
                                </el-tooltip>
                            </template>


                            <template>
                                <QuestionnaireNotesDialog 
                                    v-if="bucket.type === 'event'"
                                    :patient="patient"
                                    :notes="getSavedOrDefaultNote(note)"
                                    :name="getContentKey('event', bucket.event, 'name')"
                                    :questionnaireTitle="note.title"
                                    :provider="bucket.provider"
                                    :providerName="getProviderNameById(bucket.provider)"
                                    :schedule="bucket.id"
                                    :eventId="note.id"
                                    :savedCharts="chartMapForPatient[note.id]"
                                    :lastPushedString="bucket.type === 'event' && note.lastPushed ? getLastPushedCategoryText(note) : ''"
                                    :date="formatDate(bucket.time)"
                                    :questionnaireDate="note.displayTime"
                                    :has-push-integration="pushIntegration.includes(bucket.provider) && bucket.type === 'event'"
                                    :emr-category="note.emrCategory"
                                    :comb-note-disabled="bucket.disabled"
                                    type="text"
                                    @push-notes="saveEventNote(bucket.note, bucket.id, bucket.provider)"
                                    ></QuestionnaireNotesDialog>

                                <OtherNotesDialog 
                                    v-else
                                    :patient="patient"
                                    :notes="note.result"
                                    :questionnaireTitle="note.title"
                                    :date="formatDate(bucket.time)"
                                    :questionnaireDate="note.displayTime"
                                ></OtherNotesDialog>
                            </template>



                            <button @click="copy(note.result)" class="questionnaire-copy-button" type="text" size="medium">
                                <i class="el-icon-copy-document"></i> Copy
                            </button>

                        </span>
                        
                        <div class="text-group">
                            <div class="text-edit">
                                <span
                                    class="edit-box"
                                    :id="note.id"
                                    v-html="getNote(note)"
                                    :style="note.length === 0 ? { color: '#da4e4e'} : {}">
                                </span>
                            </div>
                        </div>
                        <div class="bottom-section">
                            <QuestionnaireNotesDialog 
                                v-if="bucket.type === 'event'"
                                :patient="patient"
                                :notes="getSavedOrDefaultNote(note)"
                                :name="getContentKey('event', bucket.event, 'name')"
                                :questionnaireTitle="note.title"
                                :provider="bucket.provider"
                                :providerName="getProviderNameById(bucket.provider)"
                                :schedule="bucket.id"
                                :eventId="note.id"
                                :savedCharts="chartMapForPatient[note.id]"
                                :date="formatDate(bucket.time)"
                                :lastPushedString="bucket.type === 'event' && note.lastPushed ? getLastPushedCategoryText(note) : ''"
                                :questionnaireDate="note.displayTime"
                                :has-push-integration="pushIntegration.includes(bucket.provider) && bucket.type === 'event'"
                                :emr-category="note.emrCategory"
                                :comb-note-disabled="bucket.disabled"
                                type="icon"
                                @push-notes="saveEventNote(bucket.note, bucket.id, bucket.provider)">
                            </QuestionnaireNotesDialog>
                            <OtherNotesDialog 
                                v-else
                                :patient="patient"
                                :notes="note.result"
                                :questionnaireTitle="note.title"
                                :date="formatDate(bucket.time)"
                                type="icon"
                                :questionnaireDate="note.displayTime">
                            </OtherNotesDialog>
                            <span v-if="bucket.type === 'event' && note.lastPushed">{{ getLastPushedCategoryText(note) }}</span>
                            <!-- Saved notes list on a popup -->
                        </div>
                    </div>
                </el-card>
            </template>

        </div>
        <el-card v-if="!bucketNote.length" class="no-notes-section">
            <img :src="require('../image/no-notes.png')"/>
            <p class="no-notes">No Notes</p>
        </el-card>
        <EmrDialog
            v-if="emrConfirmationShow"
            :emr-data="emrConfirmationData"
            :saved-charts="chartMapForPatient[emrConfirmationData.id] ? chartMapForPatient[emrConfirmationData.id] : []"
            :patient="patient"
            @close-confirmation="emrConfirmationShow = false"
            :dialog-show="emrConfirmationShow">
        </EmrDialog>
        <ParCopNoteDialog
            v-if="showPartCopiedDialgNote"
            :emr-data="emrConfirmationDataForPartNote"
            :cop-note="copiedNote"
            :par-cop-note-id="partiallyCopiedNoteId"
            :patient="patient"
            @close-confirmation="closeParCopiedDialogNote"
            :dialog-show="showPartCopiedDialgNote">
        </ParCopNoteDialog>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'

import CopyMixin from './mixin/copy'
import ProfilerMixin from './mixin/profiler'

import NotesDialog from './NotesDialog.vue'
import QuestionnaireNotesDialog from './QuestionnaireNotesDialog.vue'
import OtherNotesDialog from './OtherNotesDialog.vue'
import EmrDialog from './EmrDialog.vue'
import ParCopNoteDialog from './PartCopiedNoteDialog.vue'
import SavedNotes from './SavedNotes.vue'

import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'


/**
 * Chart UI for all questionaire charts
 * event wise
 * @component
 */
export default {
    name: 'questionnaire-chart',

    mixins: [CopyMixin, ProfilerMixin],
    
    watch: {
        /**
         * Marks all models (buckets and notes)
         * as `true` or `false` depending on
         * `val`
         * @param {Boolean} val
         */
        selectAll: function(val) {
            if(val === true) {
                this.setAllModels(true)
                this.updateSelectedNotes()
            }
            else if(val === false) {
                this.setAllModels(false)
                this.updateSelectedNotes()
            }
        }
    },

    data() {
        let bucketNote = this.questionnaireBucketNote.filter(bucket => bucket.type === 'event')
        this.questionnaireBucketNote.forEach(bucket => bucket.type === 'other' ? bucketNote.push(bucket) : {})
        /**
         * List of all note ids in each bucket flattened
         * @type {[String]}
         */
        let allNoteIds = bucketNote.flatMap((bucket) => bucket.note.map((note) => note.id))
        /**
         * List of all bucket ids
         * @type {[String]}
         */
        let allBucketIds = bucketNote.map((bucket) => bucket.id) 
        return {
            /**
             * A model object for selecting buckets on checkbox
             * @type {Object<String, Boolean>}
             */
            allBucketModel: allBucketIds.reduce((acc, bucketId) => ({...acc, [bucketId]: false}), {}),
            /**
             * A model Object for selecting notes to be copied for checkbox
             * @type {Object<String, Boolean>}
             */
            allNotesModel: allNoteIds.reduce((acc, noteId) => ({...acc, [noteId] : false}), {}),
            /**
             * A model object to control expansion
             * of notes of every id
             */
            expandModel: {},
            /**
             * Pushing statuses for notes from different CTCs
             */
            pushingNotes: {},
            bucketNote,
            pushingEventNotes: {},
            emrConfirmationShow: false,
            emrConfirmationData: {},
            emrConfirmationDataForPartNote: {},
            copiedNote: null,
            partiallyCopiedNote: false,
            showPartCopiedDialgNote: false,
            partiallyCopiedNoteId: null,
            copiedNoteDupl: null,
            partiallyCopiedNoteIdDupl: null,
            partiallyCopiedNoteDupl: false,
            renderKey: 0,
            isBucketExpanded: bucketNote.map((_, i) => i === 0 ? true : false),
            showOpenOldNotes: false,
        }
    },

    props: {
        /**
         * List of all buckets (event-wise and other)
         * which contain charted notes
         */
        questionnaireBucketNote: {
            type: Array,
            default: () => [],
            required: true
        },
        /**
         * Whether to select all notes inside the component
         * or deselect them
         */
        selectAll: {
            type: Boolean
        },
        /**
         * Show selected notes with outline
         */
        showSelected: {
            type: Boolean,
            default: true
        },
        patient: {
            type: Object,
            required: true
        }
    },

    methods: {
        ...mapActions('provider', ['pushNote', 'pushNoteCategory']),
        formatDate,
        getFormattedLastPushed(lastPushed) {
            let arr = lastPushed.split(' ')
            if (arr.length === 5)
                return 'Last: ' + arr.slice(0, 3).join(' ') + '<br>' + arr.slice(3, 6).join(' ')
            return lastPushed
        },
        toggleEventSection(index) {
            let newValue = !this.isBucketExpanded[index]
            this.isBucketExpanded = this.bucketNote.map(_ => false)
            if (newValue)
                this.isBucketExpanded[index] = newValue
            this.renderKey += 1
        },
        getLastPushedCategoryText(note) {
            if(this.chartMapForPatient[note.id] && this.chartMapForPatient[note.id].length > 0) {
                const pushedChart = this.chartMapForPatient[note.id].findLast((chart) => chart.last_push_timestamp)
                return pushedChart ? `Last Pushed at ${formatDateTime(pushedChart.last_push_timestamp)}` : ''
            }
            if (note.hasOwnProperty('integration') && note.integration.hasOwnProperty('push_to_emr')) {
                let latestDate = 0
                let category = ''
                Object.keys(note.integration.push_to_emr).forEach(key => {
                    if (note.integration.push_to_emr[key].last_pushed > latestDate) {
                        latestDate = note.integration.push_to_emr[key].last_pushed
                        category = key
                    }
                })
                let emrTitle = category
                note.emrCategory.forEach(emrs => {
                    if (emrs.id === category)
                        emrTitle = emrs.title
                })
                return 'Last Pushed to ' + emrTitle + ' at ' + note.lastPushed
            }
            return ''
        },
        getNote(note) {
            const noteResult = this.getSavedOrDefaultNote(note)
            let reqLine = 5
            let reqStr = ''
            let arr = noteResult.replace(/\n/g, '<br>').replace(/<\/br>/g, '<br>').split('<br>')
            arr.forEach((ele, index) => {
                if (ele.length > 200) {
                    let lineSplitArr = ele.match(/.{1,200}/g)
                    reqLine -= lineSplitArr.length
                    if (reqLine <= 0) {
                        ele = ele.slice(0, 750)
                        reqLine = index + 1
                    }

                }
                if (ele.trim().length === 0)
                    reqStr += '<br>'
                else if ((reqStr + ele.trim()).length <= 850 && index < reqLine)
                    reqStr += (ele + (index === reqLine - 1  ? ' ...' : '<br>'))
            })
            return reqStr
        },
        /**
         * // Get not either from the latest note on `chartMapForPatient` if present otherwise from `note.result`
         * @param {*} note 
         */
        getSavedOrDefaultNote(note) {
            let noteResult = note.result
            if(this.chartMapForPatient[note.id] && this.chartMapForPatient[note.id].length > 0)
                noteResult = this.chartMapForPatient[note.id][this.chartMapForPatient[note.id].length - 1].text
            return noteResult
        },
        /**
         * 
         * @param {string} quesId 
         * @param {string} eventId 
         * Checks if auto push is enabled in questionnaire and profile
         */
        hasAutoPushEnabled(quesId, eventId) {
            // Get profileId using eventId
            let profileId = ''
            this.getAllProviderProfileList.forEach(profile => {
                if (profile.event.filter(id => id === eventId).length > 0)
                    profileId = profile.id
            })
            // Get the content of questionnaire and profile
            let questionnaire = this.getContent('questionnaire', quesId)
            let profile = this.getContent('profile', profileId)

            if ((profile && profile.hasOwnProperty('auto_push_to_emr') && profile.auto_push_to_emr) && (questionnaire.hasOwnProperty('emr_categories') && Object.keys(questionnaire.emr_categories).length))
                return true
            return false
        },
        /**
         * Mark all notes inside a bucket (defined by `bucketId` id)
         * as selected
         */
        selectEventBucket(checkBoxValue, bucketId) {
            // Find the bucket
            const bucketNote = this.bucketNote.find((bucket) => bucket.id === bucketId)

            if(!bucketNote)
                return

            /**
             * List of note Id's for `bucketNote`
             * @type {[String]}
             */
            const bucketNoteIds = bucketNote.note.map((note) => note.id)
            if(checkBoxValue)
                bucketNoteIds.forEach((noteId) => this.allNotesModel[noteId] = true)
            else
                bucketNoteIds.forEach((noteId) => this.allNotesModel[noteId] = false)
            // Update notes to parent
            this.updateSelectedNotes()
        },
        updateSelectedNotes() {
            const notes  = this.flattenedNotes
                // Filter notes that are selected in model and joining results
                .filter((note) => this.allNotesModel[note.id]).map((note) => note.result).join('\n\n')
            /**
             * Triggers change in questionnaire notes
             * on parent with updated notes
             * @property {String} notes Updated notes
             */
            this.$emit('change-quest-notes', notes)
        },
        /**
         * Set all models (bucket and notes) keys to `value`
         * and therefore change checkbox states
         * @param {Boolean} value
         */
        setAllModels(value) {
            Object.keys(this.allBucketModel).forEach((bucketId) => this.allBucketModel[bucketId] = value)
            Object.keys(this.allNotesModel).forEach((noteId) => this.allNotesModel[noteId] = value)
        },
        /**
         * Toggle the `noteId` key in expandModel object
         * reactively
         * @param {String} noteId The id of the note to be toggled
         */
        toggleExpandModel(noteId) {
            Vue.set(this.expandModel, noteId, !this.expandModel[noteId])
        },
        /**
         * Save Notes of a single questionnaire
         * @param {Object} noteObj Object containing note information
         * @param {String} schedule Schedule id of event that note is being sent
         * @param {String} provider  Id of the provider
         */
        saveNote(noteObj, schedule, provider) {
            const noteId = `${noteObj.questionnaire_id}:${noteObj.id}`
            let queryData
            if(noteObj.question_emrs) {
                queryData = {
                    schedule: schedule,
                    provider: provider,
                    id: this.patient.id,
                    emrs: Object.entries(noteObj.question_emrs).map(([emr_category, questionnaire_notes]) => ({
                        emr_category,
                        questionnaire_notes: {
                            [noteObj.id]: questionnaire_notes.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                        }
                    }))
                }
            }
            else {
                queryData = {
                    schedule: schedule,
                    emr_category: 'default',
                    id: this.patient.id,
                    provider: provider,
                    emrs: [{
                            emr_category: 'default',
                            questionnaire_notes: {
                                [noteObj.id]: noteObj.result.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                            }
                    }]
                }
            }
            Vue.set(this.pushingNotes, noteObj.id, true)
            this.pushNoteCategory(queryData)
                .then((response) => {
                    this.$message({
                        message: response.description,
                        type: response.success ? 'success' : 'error'
                    })
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error(error.description)
                }).finally((_) => Vue.set(this.pushingNotes, noteObj.id, false))
        },
        /**
         * Saves all notes from a single scheduled event
         * @param {[*]} noteList List of all notes in a scehdule
         * @param {String} schedule Schedule id of event that note is being sent
         * @param {String} provider  Id of the provider
         */
        saveEventNote(noteList, schedule, provider) {
            const note = noteList.reduce((noteAcc, noteObj) => ({
                ...noteAcc,
                [`${noteObj.questionnaire_id}:${noteObj.id}`]: noteObj.result
            }), {})
            const queryData = {
                schedule: schedule,
                emr_category: 'default',
                id: this.patient.id,
                provider: provider,
                note,
                questionnaire_notes: noteList.reduce((acc, noteObj) => ({
                    [noteObj.id]: noteObj.result.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, ''),
                    ...acc
                }), {})
            }
            Vue.set(this.pushingEventNotes, schedule, true)
            this.pushNoteCategory(queryData)
                .then((response) => {
                    this.$message({
                        message: response.description,
                        type: response.success ? 'success' : 'error'
                    })
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error(error.description)
                }).finally((_) => Vue.set(this.pushingEventNotes, schedule, false))
        },
        /**
         * Push to emr
         */
        openEmrConfirmationComb(data) {
            this.emrConfirmationShow = true
            this.emrConfirmationData = data
        },
        openEmrConfirmation(data) {
            const selectData = data
            if(this.partiallyCopiedNote && !this.partiallyCopiedNoteDupl) {
                this.copiedNoteDupl = this.copiedNote
                this.partiallyCopiedNoteIdDupl = this.partiallyCopiedNoteId
                this.partiallyCopiedNoteDupl = this.partiallyCopiedNote
                this.openPartiallyCopiedNoteDialg(selectData)
            }
            else this.openEmrConfirmationDialg(selectData)
        },
        openEmrConfirmationDialg(data) {
            this.emrConfirmationShow = true
            this.emrConfirmationData = data
        },
        getAllPushEmrCategories(emrCategory, notes) {
            const notesCategories = notes.flatMap((note) => note.emrCategory)
            return emrCategory.map((emrCat) =>({
                ...emrCat,
                already_pushed: notesCategories.filter((note) => note.id === emrCat.id).every((note) => note.last_pushed && note.last_pushed !== '')
            }))
        },
        partialNoteSelected(partNote, noteId, clickedOut) {
            if(partNote == null && clickedOut) {
                this.copiedNote = null
                this.partiallyCopiedNoteId = null
                this.partiallyCopiedNote = false
                this.copiedNoteDupl = null
                this.partiallyCopiedNoteIdDupl = null
                this.partiallyCopiedNoteDupl = false
            } else if(partNote == null && !clickedOut) {
                this.copiedNoteDupl = null
                this.partiallyCopiedNoteDupl = false
                this.partiallyCopiedNoteIdDupl = null
            } else {
                this.copiedNote = partNote.replaceAll('\n', '<br> <br>')
                this.partiallyCopiedNoteId = noteId
                this.partiallyCopiedNote = true
                this.copiedNoteDupl = partNote.replaceAll('\n', '<br> <br>')
                this.partiallyCopiedNoteIdDupl = noteId
                this.partiallyCopiedNoteDupl = true
            }
        },
        openPartiallyCopiedNoteDialg(data) {
            this.showPartCopiedDialgNote = true
            this.emrConfirmationDataForPartNote = data
        },
        closeParCopiedDialogNote() {
            this.showPartCopiedDialgNote = false 
            this.copiedNote = null
            this.copiedNoteDupl = null
            this.partiallyCopiedNote = false
            this.partiallyCopiedNoteId = null
            this.partiallyCopiedNoteIdDupl = null
            this.emrConfirmationDataForPartNote = {}
        }
    },

    computed: {
        ...mapGetters('content', [
            'getContent',
            'getContentKey'
        ]),
        ...mapGetters('provider', [
            'getProviderNameById',
            'getAllProviderProfileList'
        ]),
        ...mapState('provider', {
            pushIntegration: state => state.pushIntegration,
            chartMap: state => state.record.charts
        }),
        /**
         * Calcates list of all notes from every bucket in a
         * single array
         */
        flattenedNotes() {
            try {
                return this.bucketNote.flatMap((bucket) => bucket.note)
            } catch (error) {
                console.error('Error calculating flattened notes ', error)
                return []
            }
            
        },
        chartMapForPatient() {
            return  this.chartMap[this.patient.id]
        }
    },

    components: {
        NotesDialog,
        QuestionnaireNotesDialog,
        OtherNotesDialog,
        EmrDialog,
        ParCopNoteDialog,
        SavedNotes
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.info {
    display: flex;
    background-color: #FFF3E3;
    color: #FA9E25;
    margin-bottom: -10px;
    padding: 8px 12px;
    font-size: 12px;
    line-height: 15px;
    max-width: 200px;
    img {
        height: 10px;
        width: 10px;
        margin-right: 5px;
        margin-top: 2px;
    }
}

.chart {
    background-color: #ffffff;
    .bucket-header {
        background-color: #F8F8F8;
        margin: 15px 0;
    }
}
.event-section {
    margin-bottom: 10px;
    background-color: #f8f8f8;
    padding-top: 1px;
    padding-bottom: 5px;
}
.event-section:first-child {
    margin-top: 10px;
}
.event-section:last-child {
    margin-bottom: 0;
}

.bottom-section {
    display: block;
    width: 100%;
    height: 0px;
    color: #666666;
    font-size: 11px;
    span {
        float: right;
        margin-right: 10px;
        margin-top: 5px;
    }
}
.autopush-icon {
    height: 18px;
    width: 18px;
    margin-right: 5px;
    margin-bottom: -4px;
    cursor: pointer;
}

.push-btn-container {
    float: right;
}

.push-button, .push-button:hover {
    line-height: 0;
    font-weight: 500;
    float: right;
    font-size: 13px;
    color: #ffffff;
    height: 26px;
    margin-left: 10px;
    background-color: #833e93;
    border: none;
    border-radius: 5px;
    padding: 6px 8px !important;
    i {
        font-size: 11px;
        color: #ffffff;
    }
}

.push-button:disabled {
    opacity: 0.6;
}

.dropdwn-cnt{
    display: inline-block;
    height: 45px !important;
    min-width: 250px;
}

.option-title {
    display: inline-block;
    margin-top: 6px;
}
.timestamp{
    color: #999999;
    font-size: 10px;
    width: 35%;
    position: absolute;
    right: 10px;
    display: inline-block;
    text-align: right;

    span {
        height: 15px;
        display: block;
    }
}
.mt-5 {
    margin-top: 5px;
}
.bucket-emr {
    button.disabled {
        opacity: 0.5;
    }
}
.smart-push {
    display: flex;
    flex-direction: column;
    span {
        font-size: 9px;
        margin-top: 4px;
    }
}

</style>
